import { MaskedLine } from "@/components/Reveal";

const PageHero = ({ title, testId }) => (
  <div className="relative pt-28 sm:pt-32 pb-10 overflow-x-clip">
    <img
      src="/assets/blob.png"
      alt=""
      className="absolute -top-40 left-1/2 -translate-x-1/2 w-[110%] max-w-none opacity-70 pointer-events-none select-none"
    />
    <img
      src="/assets/waves.png"
      alt=""
      className="absolute top-[30px] sm:top-[60px] left-1/2 -translate-x-1/2 w-[118%] max-w-none pointer-events-none select-none"
    />
    <div className="relative site-container">
      <h1 data-testid={testId} className="text-5xl sm:text-6xl lg:text-[64px] font-medium tracking-tight">
        <MaskedLine>
          <span className="inline-flex items-center gap-3 sm:gap-4 leading-none">
            <span className="leading-none">{title}.</span>
            <span className="hidden font-light text-[#111]/80 leading-none lg:inline">—</span>
            <img
              src="/assets/globe.svg"
              alt=""
              className="hidden shrink-0 self-center lg:block"
              style={{ width: "1.2em", height: "1.2em", marginTop: "4px" }}
            />
          </span>
        </MaskedLine>
      </h1>
    </div>
  </div>
);

export default PageHero;
